import { Text, Pressable, type TextProps } from 'react-native';
import React from 'react';

type TypographyProps = {
  children?: React.ReactNode;
  style?: any;
  numberOfLines?: number;
  onPress?: () => void;
} & Omit<TextProps, 'style'>;

const Typography = ({
  children,
  style,
  numberOfLines,
  onPress,
  ...rest
}: TypographyProps) => {
  const text = (
    <Text style={style} numberOfLines={numberOfLines} {...rest}>
      {children}
    </Text>
  );
  if (onPress) {
    return (
      <Pressable
        onPress={onPress}
        style={({ pressed }) => [{ opacity: pressed ? 0.7 : 1 }]}>
        {text}
      </Pressable>
    );
  }
  return text;
};

export default Typography;
